var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChatbotBubbleIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3751 64.7682C71.8254 64.2234 71.8364 63.3655 72.2766 62.7305C75.3155 58.3462 77.0938 53.0374 77.0938 47.3172C77.0938 32.2606 64.7729 20.0548 49.5743 20.0548C34.3757 20.0548 22.0548 32.2606 22.0548 47.3172C22.0548 58.7969 29.1028 67.8802 39.2545 72.4497C44.3268 74.7329 48.7363 75.4315 55.5942 75.4315C63.276 75.4315 70.5451 73.681 77.0173 70.5607C78.4384 69.8756 79.4452 68.7184 76.755 67.5394C76.1311 67.266 75.5245 66.9608 74.9373 66.626C73.9876 66.1391 73.1241 65.5104 72.3751 64.7682Z",
    fill: "#7436B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_72",
    x: 0.0548096,
    y: 0.0548096,
    width: 100.385,
    height: 99.3767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_72",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChatbotBubbleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chatbot-bubble-icon.4736237c.svg";
export { ForwardRef as ReactComponent };